/* istanbul ignore file */
import { number as codecNumber } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { InlineFeedbackAnalyticsData } from './InlineFeedbackAnalyticsData';
import { RubricAnalyticsData } from './RubricAnalyticsData';
import { SubmissionsAnalyticsData } from './SubmissionsAnalyticsData';
const AnalyticsDataParser = /* #__PURE__ */ parsers.object([
    ['workId', codecNumber, 'work_id'],
    [
        'data',
        /* #__PURE__ */ parsers.taggedUnion('tag', [
            ['rubric', RubricAnalyticsData],
            ['inline-feedback', InlineFeedbackAnalyticsData],
            ['submission', SubmissionsAnalyticsData],
        ]),
    ],
]);
export class AnalyticsData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return AnalyticsDataParser.decode(input).map(res => new AnalyticsData(res));
    }
    static unsafeDecode(input) {
        return AnalyticsData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return AnalyticsDataParser.encode(data);
    }
    static schema() {
        return AnalyticsDataParser.schema();
    }
}
